// !!!IMPORTANT!!! Add any other backend actions here to stay in sync with MiddlewareResponseActions.cs
export const MiddlewareResponseActions = {
    Logout: 'logout',
};